import React, { useState, useEffect } from "react";
import { PostData } from "../../../service/postData";
import { sendNotification } from "../../../_notificationSettings/notificationPanel";
import { MDBDataTableV5 } from "mdbreact";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import moment from "moment";

global.BACK_URL = "Business";

const columns = [
  { label: "#", field: "srNo", width: 20 },
  { label: "Title", field: "title", width: 150 },
  { label: "Amount", field: "plan_amount", width: 20 },
  { label: "Setup Amount", field: "setup_amount", width: 20 },
  { label: "Country", field: "country_name", width: 30 },
  { label: "Intervel", field: "plan_type", width: 30 },
  { label: "Date", field: "added_on", width: 150 },
  { label: "Status", field: "status", width: 100 },
  { label: "Action", field: "action", width: 100 },
];

const MasterPlanList = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [setupArray, setSetupArray] = useState([]);

  useEffect(() => {
    fetchPlans();
  }, []);

  const fetchPlans = async () => {
    try {
      const response = await fetch(
        `${global.API_STRIPEAPI_URL}getAllPlansForAdmin`
      , {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });
      const data = await response.json();

      if (!response.ok) {
        console.error(data.error || "Something went wrong");
      } else {
        setSetupArray(data);
        setIsLoaded(true);
      }
    } catch (error) {
      console.error("Fetch error:", error);
      setIsLoaded(true);
    }
  };

  const clickToDelete = (value) => {
    confirmAlert({
      title: "Confirm to delete",
      message: "Are you sure you want to delete?",
      buttons: [
        {
          label: "Yes",
          className: "btn btn-danger",
          onClick: async () => {
            const requestData = JSON.stringify({ productId: value });
            try {
              const response = await fetch(
                `${global.API_STRIPEAPI_URL}deletePlanWithPrice`,
                {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                  },
                  body: requestData,
                }
              );

              const result = await response.json();

              if (response.ok) {
                sendNotification(
                  "Success Message 👍",
                  result.message,
                  "success"
                );
                fetchPlans();
              } else {
                sendNotification("Error Message 😓", result.message, "danger");
              }
            } catch (error) {
              sendNotification(
                "Network Error 🚨",
                "Something went wrong while updating the plan.",
                "danger"
              );
            }
            // PostData(url, requestData, "POST").then((result) => {
            //   if (!result.success) {
            //     sendNotification("Error Message 😓", result.message, "danger");
            //   } else {
            //     sendNotification("Welcome Back 👍", result.message, "success");
            //     fetchPlans();
            //   }
            // });
          },
        },
        {
          label: "No",
          className: "btn btn-dark",
        },
      ],
    });
  };

  const clickToStatus = (productId, isActive) => {
    confirmAlert({
      title: "Confirm to manage status",
      message: "Are you sure you want to change the status?",
      buttons: [
        {
          label: "Yes",
          className: "btn btn-danger",
          onClick: async () => {
            const requestData = JSON.stringify({ productId, isActive: !isActive });

            try {
              const response = await fetch(
                `${global.API_STRIPEAPI_URL}toggleProductAndPriceStatus`,
                {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                  },
                  body: requestData,
                }
              );

              const result = await response.json();

              if (response.ok) {
                sendNotification(
                  "Success Message 👍",
                  result.message,
                  "success"
                );
                fetchPlans();
              } else {
                sendNotification("Error Message 😓", result.message, "danger");
              }
            } catch (error) {
              sendNotification(
                "Network Error 🚨",
                "Something went wrong while updating the plan.",
                "danger"
              );
            }
          },
        },
        {
          label: "No",
          className: "btn btn-dark",
        },
      ],
    });
  };

  const loadMasterPlanListing = (data) => {
    const rows = data.map((row, index) => {
      // `active` on vs_stripe_prices is a BOOLEAN — Postgres returns
      // true/false, not 1/0. The old strict `=== 1` check was always
      // false, so every plan (even ones just activated) rendered as
      // "Disabled". Treat both shapes as active.
      const isActive = row.active === true || row.active === 1 || row.active === '1';
      const statusBadge = isActive ? (
        <span className="badge badge-success">Enabled</span>
      ) : (
        <span className="badge badge-danger">Disabled</span>
      );

      return {
        srNo: row.id || index + 1,
        title: row.productName,
        country_name: row.countryName,
        plan_amount: row.amount,
        setup_amount: row.setup_amount,
        plan_type: row.interval_type,
        status: statusBadge,
        added_on: moment(row.created_at).format("DD-MM-YYYY"),
        action: (
          <div className="btn-group" role="group">
            <button
              type="button"
              className="btn btn-secondary dropdown-toggle"
              id="btnGroupVerticalDrop3"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <i className="si si-list"></i>
            </button>
            <div
              className="dropdown-menu"
              aria-labelledby="btnGroupVerticalDrop1"
            >
              <a
                className="dropdown-item"
                href={`${global.webUrl}administrator/add-master-plan/?prod_id=${row.id}`}
              >
                <i className="si si-pencil mr-5 text-info"></i>Edit Details
              </a>
              <a
                className="dropdown-item"
                href="#!"
                onClick={() => clickToStatus(row.stripe_product_id, row.active)}
              >
                <i className="fa fa-exclamation-triangle mr-5 text-primary"></i>
                Manage Status
              </a>
              <a
                className="dropdown-item"
                href="#!"
                onClick={() => clickToDelete(row.stripe_product_id)}
              >
                <i className="si si-trash mr-5 text-danger"></i>Delete
              </a>
            </div>
          </div>
        ),
      };
    });

    return {
      columns,
      rows,
    };
  };

  return (
    <>
      <div className="content">
        <div className="content-header">
          <div className="header-section">
            <h1 className="content-heading">
              <i className="gi gi-direction"></i>Manage Master Plan List
            </h1>
          </div>
        </div>
        <nav className="breadcrumb push">
          <a
            className="breadcrumb-item"
            href={`${global.webUrl}administrator/dashboard/`}
          >
            Dashboard
          </a>
          <a
            className="breadcrumb-item"
            href={`${global.webUrl}administrator/add-master-plan/`}
          >
            Add New Master Plan
          </a>
          <span className="breadcrumb-item active">
            Manage Master Plan List
          </span>
        </nav>

        <div className="block">
          <div className="block-header block-header-default">
            <h3 className="block-title">List of Master Plan</h3>
          </div>
          <div className="block-content">
            <MDBDataTableV5
              hover
              entriesOptions={[25, 50, 100]}
              entries={25}
              pagesAmount={4}
              span
              pagingTop
              searchTop
              searchBottom={false}
              barReverse
              data={loadMasterPlanListing(setupArray)}
            />
          </div>
        </div>
      </div>

      <div
        id="global_loader"
        className={`glb-ldr-prt ${isLoaded ? "" : "active"}`}
      >
        <div className="gl-ldr-cld">
          <div className="gl-ldr-ctr">
            <div className="gl-loader"></div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MasterPlanList;
